<template>
  <div class="container-fluid mt-2">
    <h2>Daten-Tabelle</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button @click="save()" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
        <button @click="exportTable()" class="btn btn-secondary"><font-awesome-icon icon="download"/>&nbsp;Tabelle einlesen</button>
      </div>
      <div v-if="system" class="input-group">
        <input true-value="1" false-value="0" id="deltaflag" v-model="deltaUpdate" type="checkbox" class="form-check-input"/>
        <label for="deltaflag">Delta Update</label>
      </div>
    </div>
    <b-tabs class="mt-3">
      <b-tab title="Tabelle">
        <div class="container mt-2">
          <div class="form-group">
            <label>Tabellen-Name:</label>
            <input type="text" :disabled="system" class="form-control" v-model="name"/>
          </div>
        </div>
        <div class="row">
          <MultiTableSource ref="msource" @delete="deleteTable" @edit="openTable" @editjoin="editJoin" :sources="sources" :tables="tables" v-show="!editMode"/>
          <DataTableEditor :colTemplates="sysTemplates" ref="tableeditor" :isjoin="editJoinFlag" @test="testTable" @save="submitTable" :table="editTable" :source="editSource" v-show="editMode"/>
        </div>
      </b-tab>
      <b-tab title="Konvertierung">
        <div class="container mt-2" style="height:500px;">
          <AceEditor ref="editor" :editorId='"ceditor"' :lang="'javascript'" :content="convertScript"/>
        </div>
        <div class="container-fluid">
          <h4>Hinweis</h4>
          <p>
            Das Skript kann zur Umwandlung der Objekte genutzt werden. Die Daten werden als Variable (<i>data</i>) im Skript zur Verfügung gestellt.
            Über data.get(0) wird z.B. das erste Element ausgelesen. Die Anzahl der vorhandenen Elemente kann man mit <i>data.size();</i> auslesen. Jedes Element kann alle Attribute über <i>elem.get("mein_id")</i> zurück geben.
            Die neu entstandenen Objekte können als JSON Array (<i>[{...},{...},{...}]</i>) zurück in das Drain Objekt gegeben werden.
            Ist das neue Daten Array z.B. in der Variable <i>newlist</i>, können die Daten einfach per <i>drain.drainObjects(newlist);</i> ausgegeben werden.
          </p>
        </div>
      </b-tab>
    </b-tabs>
    <b-modal id="testResults" size="lg" title="Test-Ergebniss" ok-only>
      <div class="wrapper">
        <textarea rows="50" v-model="testResults" class="form-control">
        </textarea>
      </div>
    </b-modal>
    <b-modal id="exportConfig" size="xl" title="Export Einstellungen" @ok="runExport">
      <ExportConfigWidget :config="exportCfg" :columns="columns" :download="true"/>
    </b-modal>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import rules  from '@/modules/rules.js'
import datamap from '@/modules/datamap.js'
import AceEditor from '@/components/AceEditor.vue'
import ExportConfigWidget from '@/components/genericdata/ExportConfigWidget.vue'
import MultiTableSource from '@/components/genericdata/MultiTableSource.vue'
import DataTableEditor from '@/components/genericdata/DataTableEditor.vue'

export default {
  name: 'DataTableEditorView',
  components: {
    DataTableEditor,
    MultiTableSource,
    AceEditor,
    ExportConfigWidget,
  },
  data() {
    return {
      exportCfg: {extend:{}},
      convertScript: '',
      sources: [],
      tables: [],
      type: "normal",
      name: "",
      system: false,
      editMode: false,
      editTable: {name:""},
      editSource: {},
      editColumns: [],
      editJoinFlag: false,
      testResults: '',
      deltaUpdate: false,
      sysTemplates: [],
      columns: []
    }
  },
  mounted: function() {
    var self = this;
    datamap.listsources(this,0,100,function(data) {
      self.sources = data;
    })
    config.listSystemTables().then(resp => resp.json()).then(function(data) {
      console.log(data);
      self.sysTemplates = data;
    })
    console.log(this.$route.params.name);
    if (this.$route.params.name) {
      var tname = this.$route.params.name;
      // check system table
      if (this.$route.params.sys) {
        this.tables = [];
        this.name   = tname;
        this.system = true;
        datamap.loadsystable(this,tname,function(data) {
          if (data && data['data.mapping.' + tname]) {
            var tables = JSON.parse(data['data.mapping.' + tname]);
            console.log('test start: ' + tname);
            console.log(tables);
            self.tables = tables;
          }
        })
        // load convert script
        rules.load('data.mapping.' + tname,function(data) {
          if (data && data.script) {
            self.$refs.editor.setContent(data.script);
          }
        })
        // check delta Update
        config.loadcfg(["data.mapdelta." + tname],this,function(data) {
          console.log(data);
          self.deltaUpdate = data["data.mapdelta." + tname];
        });
      // systable
      } else {
        datamap.loadtable(this.$route.params.name,this,function(data) {
          console.log(data);
          if (data.name) self.name = data.name;
          if (data.config && data.config.tables) self.tables = data.config.tables;
          if (data.convertscript) self.$refs.editor.setContent(data.convertscript); else self.$refs.editor.setContent('');
          self.listColumns();
        });
      }// normal table
    } // load table
  },
  methods: {
    listColumns() {
      console.log('list columns.......');
      this.columns = datamap.listcolumns(this.tables);
    },
    exportTable: function() {
      var self = this;
      if (this.system) {
        console.log('system tabelle einlesen');
        config.get(this,config.baseUrl + 'rest/jobs/control?action=' + encodeURIComponent(this.name),'System Import starten.',function() {
          self.$bvToast.toast('System Tabelle wird aktualisiert',{title: 'Daten Mapping',variant: 'success'})
        });
      } else {
        console.log('unknown todo :(');
        this.$bvModal.show('exportConfig');
      }
    },
    downloadBlob(blob,filename) {
      const blobURL = window.URL.createObjectURL(blob);
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename)
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      setTimeout(() => {
        window.URL.revokeObjectURL(blobURL);
      }, 500);      
    },
    runExport: function() {
      console.log('run');
      console.log(JSON.stringify(this.exportCfg));
      var download = !!this.exportCfg.download;
      var filename = 'export.dat';
      if (download) {
        if (this.exportCfg.exporttype == 'xls') {
          filename = 'export.xlsx';
        } else if (this.exportCfg.exporttype == 'text') {
          filename = 'export.txt';
        } else if (this.exportCfg.exporttype == 'json') {
          filename = 'export.json';
        }
      }
      var self = this;
      datamap.exporttable(this,this.name,this.exportCfg,download,function(data) {
        if (download)
          self.downloadBlob(data,filename);
        self.$bvToast.toast('Tabellenexport gestartet.',{title: 'Data Mapping',variant: 'success'});
      })
    },
    openConvert: function() {
      console.log('test');
    },
    testTable: function() {
      var self = this;
      config.post(this,config.baseUrl + 'rest/datamap/tablecheck','Tabelle testen',JSON.stringify({table: this.editTable, datasource: this.editSource }),function(data) {
        self.testResults = JSON.stringify(data,null,'\t');
        self.$bvModal.show('testResults');
      });
    },
    openTable: function(idx) {
      this.editTable = this.$refs.msource.tables[idx].table;
      this.editSource = this.$refs.msource.tables[idx].datasource;
      if (this.editSource.refid) this.editSource.type = 'referer';
      this.editJoinFlag = false;
      this.editMode = true;
      console.log(JSON.stringify(this.editSource));
    },
    editJoin: function(idx) {
      this.editTable = this.$refs.msource.tables[idx.tidx].table.joins[idx.jidx].table;
      this.editSource = this.$refs.msource.tables[idx.tidx].table.joins[idx.jidx].datasource;
      if (this.editSource.refid) this.editSource.type = 'referer';
      this.editJoinFlag = this.$refs.msource.tables[idx.tidx].table;
      this.editMode = true;
      console.log('editor table');
      console.log(this.editTable);
      console.log(JSON.stringify(this.editSource));
    },
    deleteTable: function(idx) {
      if (confirm('Möchten Sie die Tabelle wirklich löschen?')) {
        this.tables.splice(idx,1);
      }
    },
    submitTable: function() {
      this.editMode = false;
    },
    save: function() {
      if (this.name == "") {
        this.$bvToast.toast('Bitte erst einen Namen angeben.',{ title: 'Warnung', variant: 'warning'});
        return;
      }
      var self = this;
      var data;
      if (this.system) {
        var rdata = {};
        data = {}
        data['data.mapping.' + this.name] = JSON.stringify(this.tables);
        rdata.ruleId = 'data.mapping.' + this.name;
        rdata.script = this.$refs.editor.getContent();
        rules.save(rdata,function() {
          self.$bvToast.toast('Konvertierungs-Skript gespeichert', { title: 'WaWi Mapping', variant:'success' })
        });
        datamap.savesystable(this,data,function() {
          self.$bvToast.toast('System-Tabelle gespeichert.',{ title: 'WaWi Mapping', variant: "success"})
        })
        var dup = {};
        dup["data.mapdelta." + this.name] = this.deltaUpdate;
        config.savecfg(dup,this);
      // systable
      } else {
        data = { name: this.name, type: this.type,config: { tables: this.tables }, convertscript: this.$refs.editor.getContent() };
        console.log(data);
        datamap.savetable(this,data,function() {
          self.$bvToast.toast('Tabelle gespeichert.',{ title: 'Tabellen',variant: "success"});
        });
      }
    }
  }
}
</script>
